/*
 * Copyright (c) 2020
 * Company: G-Portal
 * Filename: events
 * Class: events
 * Author: Karl Magerl<karl@g-portal.com>
 * Version:
 */

export enum Events {
    OpenGamecloudEditModal = 'Gamecloud Edit Modal',
    OpenServerUnitEditModal = 'Server Units Modal',
    OpenRechargeModal = 'Recharge Modal',
    OpenSearchOverlay = 'openSearchOverlay',
    HideSearchOverlay = 'hideSearchOverlay'
}
